import axios from "axios";
import { isOrderPaidBySquareOrAdmin } from "../../components/admin/adminOrderPaymentStatus";

export async function markOrdersPaid(apiBaseUrl, ids) {
  const result = { paid: [], skipped: [], failed: [] };
  for (const id of new Set(ids)) {
    let label = id;
    try {
      const { data: order } = await axios.get(`${apiBaseUrl}/orders/${encodeURIComponent(id)}`);
      label = order.order_no || id;
      const hasRefund = [order.refund_status, order.square_refund_status].some(value => value && !["none", "not_requested"].includes(String(value).toLowerCase()));
      if (hasRefund || [order.status, order.payment_status].some(value => /cancel|delet|refund/i.test(String(value || "")))) {
        result.skipped.push(`${label}：已取消、删除或涉及退款`);
        continue;
      }
      if (isOrderPaidBySquareOrAdmin(order)) {
        result.skipped.push(`${label}：已付款`);
        continue;
      }
      await axios.put(`${apiBaseUrl}/orders/${encodeURIComponent(id)}`, { payment_already_received: true });
      // The generic update endpoint may ignore fields without finance permission.
      const { data: saved } = await axios.get(`${apiBaseUrl}/orders/${encodeURIComponent(id)}`);
      if (!isOrderPaidBySquareOrAdmin(saved)) throw new Error("保存后未显示已付款，请检查收款权限或订单状态");
      result.paid.push(id);
    } catch (error) {
      result.failed.push({ id, message: `${label}：${error.response?.data?.detail || error.message || "标记失败"}` });
    }
  }
  return result;
}
